import { api } from "../../services/api";

export async function fetchChavePix() {
  const token = localStorage.getItem("@medusapayments:access_token");

  try {
    const response = await api.get("/historykeypix", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });

    return {
      data: response.data || []
    };
  } catch (error) {
    throw error?.response?.data || error;
  }
}

// DELETE
export async function excluirChavePix(chaveId) {
  const token = localStorage.getItem("@medusapayments:access_token");

  try {
    const response = await api.post(
      `/delpix`,
      {
        id: chaveId
      },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
}

// POST (caso queira criar nova chave aleatória)
export async function adicionarChavePix({
  tipo,
  chave,
  documento,
  nomeTitular
}) {
  const token = localStorage.getItem("@medusapayments:access_token");

  try {
    const response = await api.post(
      `/keypix`,
      {
        type_key: tipo,
        key_pix: chave,
        document: documento,
        nametitle: nomeTitular
      }, // ou algum corpo, se necessário
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );

    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
}
